import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/SiteShell";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { UPPROMOTE_LOGIN_URL } from "@/lib/uppromote/joinSchema";

export const Route = createFileRoute("/ambassadors/joined")({
  head: () => ({
    meta: [
      { title: DICTS.en["upjoin.success.meta"] },
      { name: "description", content: DICTS.en["upjoin.success.body"] },
      { property: "og:title", content: DICTS.en["upjoin.success.meta"] },
      { property: "og:description", content: DICTS.en["upjoin.success.body"] },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: Joined,
});

function Joined() {
  const { t, dir } = useLocale();
  return (
    <SiteShell>
      <div className="mx-auto max-w-xl px-4 py-16 text-center space-y-4" dir={dir}>
        <h1 className="t-h2 text-foreground">{t("upjoin.success.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("upjoin.success.body")}</p>
        <a href={UPPROMOTE_LOGIN_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center border border-foreground bg-foreground px-5 py-2.5 text-[12px] uppercase tracking-[0.14em] text-background">
          {t("lecmoamb.dashboard")}
        </a>
        <p className="text-xs text-muted-foreground">{t("lecmoamb.joined_note")}</p>
        <Link to="/" className="inline-flex min-h-[44px] items-center border border-foreground px-5 py-2.5 text-[12px] uppercase tracking-[0.14em] text-foreground">
          {t("upjoin.success.cta")}
        </Link>
      </div>
    </SiteShell>
  );
}
